import { Impargo as impargoTheme } from '@impargo/components/Themes';
import { impargoLight } from '@impargo/design-tokens';
export const theme = Object.assign(Object.assign({}, impargoTheme), impargoLight);
